let Vue = require('vue');
let Promise = require('bluebird');

Vue.directive('maxlength', {
    twoWay: true,
    priority: 1000,
    params: [],
    bind: function () {
        $(this.el).maxlength({
            alwaysShow: true,
            warningClass: "label label-primary",
            limitReachedClass: "label label-danger",
            separator: ' de ',
            preText: '',
            postText: ' ',
            validate: true
        });
    },
    update: function () {

    },
    unbind: function () {

    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/maxlength.js